import React from "react";
import "./about.css";
import ME from "../../../images/Lucky-about.jpg";
import { FiAward } from "react-icons/fi";
import { HiUsers } from "react-icons/hi";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="" />
          </div>
        </div>

        <div className="about__content__wrapper">
          <div className="about__content">
            <div className="about__cards">
              <article className="about__card">
                <FiAward className="about__icon" />
                <h5>Experience</h5>
                <small>2+ Years</small>
              </article>
              <article className="about__card">
                <HiUsers className="about__icon" />
                <h5>Clients</h5>
                <small>6+ Overall India</small>
              </article>
              <article className="about__card">
                <VscFolderLibrary className="about__icon" />
                <h5>Projects</h5>
                <small>8+ Completed</small>
              </article>
            </div>
          </div>

          <div className="about__content">
            <div className="about__cards">
            </div>
          </div>

          <div className="about__content">
            <div className="about__cards">
            </div>
          </div>
          <p className="about__para">
          I'm a proud citizen of India, pursuing B.Tech in CSE from IIIT Dharwad. I really enjoy learning languages and developing some non-existing outcomes to solve real-life problems. I'm excited to work on different projects along with the people around me.
          <br/>
          🔭 I'm currently working on Web Development And Web3.
          <br/>
          🌱 I'm currently learning  👨‍💻 competitive programming 🤖-Machine Learning.
          </p>

          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
